import { getNextStep, getPreviousStep } from 'config/StepsOrder';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { StepParamsSelector } from 'store/selectors';

export default function useStepNavigation(currentRoute: string) {
  const stepParams = useSelector(StepParamsSelector);
  const navigate = useNavigate();

  const navigateToNextStep = useCallback(() => {
    navigate(getNextStep(stepParams, currentRoute));
  }, [navigate, stepParams, currentRoute]);

  const navigateToPreviousStep = useCallback(() => {
    navigate(getPreviousStep(stepParams, currentRoute));
  }, [navigate, stepParams, currentRoute]);

  return {
    navigateToNextStep,
    navigateToPreviousStep,
  };
}
